import { Tooltip } from 'antd';

const SummaryCard = ({ icon, label, tooltip, mainValue, subText }) => (
  <Tooltip title={tooltip} placement="topLeft">
    <div className="kpi-card">
      <div className="kpi-card-content">
        <div className="kpi-card-main">
          <div className="kpi-label">{label}</div>
          <div className="kpi-value">{mainValue}</div>
          {subText && <div className="kpi-sub">{subText}</div>}
        </div>
        <div className="kpi-icon">{icon}</div>
      </div>
    </div>
  </Tooltip>
);

export default SummaryCard;
